"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const contexts_1 = require("@App/contexts");
const RelinquishmentConfirmationPopup = (props) => {
    const [hasConfirmed, setHasConfirmed] = (0, react_1.useState)(false);
    const { overclaimViewStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { onClose } = props;
    const onCancel = () => {
        setHasConfirmed(false);
        onClose();
    };
    const onRelinquishShares = () => {
        overclaimViewStore
            .createOverclaimRelinquishment()
            .catch(() => {
            setHasConfirmed(false);
            popupStore.setAlertData('An error has occurred. Relinquishment was not successful.', true);
            onClose();
        })
            .finally(() => {
            setHasConfirmed(true);
        });
    };
    return (react_1.default.createElement(Popup_1.default, { onClose: onClose }, !hasConfirmed ? (react_1.default.createElement(ConfirmationPopup_1.default, { title: 'You are about to relinquish all of your shares on this work.', onCancel: onCancel, cancelButtonText: 'Cancel', onConfirm: onRelinquishShares, confirmButtonText: 'Confirm' }, `By clicking "Confirm" below, you are confirming that 
                    you want to relinquish all of your current 
                    shares on this work and have the work removed from your catalog. 
                    Click "Cancel" to return to the overclaim detail page.`)) : (react_1.default.createElement(ConfirmationPopup_1.default, { title: 'Your shares on this work have been relinquished.', onConfirm: onClose, confirmButtonText: 'Done' },
        react_1.default.createElement("span", null,
            "Your shares will be removed from this work and the work will be removed from your catalog within approximately one business day. If you have relinquished your shares by mistake, please contact us ",
            react_1.default.createElement("a", { href: 'https://portal.themlc.com/contact-us' }, " here. "))))));
};
exports.default = RelinquishmentConfirmationPopup;
